<template>
    <div class="flex-1 h-full flex flex-col justify-between overflow-hidden">
		<div class="title ">{{ this.currentConversation.chat_name }}</div>
        <div class="right_center flex-1" ref="pdfscroll">
            <div class="relative w-full h-full">
				<p class=" text-center text-gray-400 text-sm py-3 text-[14px]"> 没有更多了 </p>
                <div
                    v-for="(item, index) in currentConversation.message"
                    :key="index"
                >
                    <PDFChatItem
						:PDFChatItem="item"
						:isFetching='isFetching' 
						:timeShow="index ==0 || item.time != currentConversation.message[index-1]?.time ? true : false"
						@handleClick="$emit('handleClick', 'close')"
					></PDFChatItem>
                </div>
				<p v-if="chatTimeout && timeoutShow" class=" text-center text-gray-400 text-sm py-3 text-[14px]"> 文档上传超过48小时，无法继续提问文档内容<br />如需继续阅读，请新建会话重新上传文档 </p>
            </div>
        </div>
        <PDFChatBtm @send="handeleSend" :qaType="qaType" :isFetching="isFetching"></PDFChatBtm>
    </div>
</template>

<script>
import PDFChatItem from "@/components/pdf/PDFChatItem.vue";
import PDFChatBtm from "@/components/pdf/PDFChatBtm.vue";

export default {
	props:['currentConversation', 'isFetching'],
    components: {
        PDFChatItem,
        PDFChatBtm
    },
    data() {
        return {
            inputValue: "",
            // isFetching: false, // 是否在生成中
			qaType: 'qa',     // 点击发布是 pdf 解析 还是 qa 问题
			timeoutShow: true,
        }
    },
    methods: {
        scrollSmooth() { // 平滑滚动到底部
			this.$nextTick(()=>{
				let web_scrollEl = this.$refs.pdfscroll;
				web_scrollEl.scrollTo({ 
					top: web_scrollEl.scrollHeight, 
					behavior: 'smooth' 
				});
			})
		},
		topScroll() {
			this.$nextTick(()=>{
				let web_scrollEl = this.$refs.pdfscroll;
				web_scrollEl.scrollTo({ 
					top: 0, 
					behavior: 'smooth' 
				});

			})
		},
        bottomScroll() { // 页面随内容增加滚动到最底部
			this.$nextTick(()=>{
				// if (this.device !='mobile') {
					let web_scrollEl = this.$refs.pdfscroll;
					if (web_scrollEl) {
						web_scrollEl.scrollTop = web_scrollEl.scrollHeight;
					}
				// } else {
				// 	console.log('333333333')
				// 	let mobile_scrollEl = this.$refs.mobilescroll;
				// 	mobile_scrollEl.scrollTop = mobile_scrollEl.scrollHeight;
				// }
			})
		},
		// 发送消息后回调 页面滚动到最下面
		handeleSend(){
			this.scrollSmooth()
		},
    },
	created(){
		// 发送消息时 页面随内容增加滚动到最底部
		this.$bus.$on('pdfChatScroll',()=>{
			this.timeoutShow = false
			this.bottomScroll()
		})
		// 接受 pdfFetching 状态
		// this.$bus.$on('pdfFetching', (status)=>{
		// 	console.log('=================');
		// 	console.log(status);
		// 	console.log(this.isFetching);
		// 	console.log('=================');
		// 	this.isFetching = status
		// 	console.log('=================');
		// 	console.log(status);
		// 	console.log(this.isFetching);
		// 	console.log('=================');
		// })
	},
	mounted(){
		this.$nextTick(()=>{
			console.log(this.$refs.pdfscroll);
			if (this.$refs.pdfscroll) {
				this.scrollSmooth()

			}
		})
	},
	computed:{
		chatTimeout(){
			const created_at = new Date(this.currentConversation.created_at).getTime()
			const now = new Date().getTime()
			const timeout = now - created_at
			return timeout > 1000 * 60 * 60 * 24 * 2
		}
	}

}
</script>

<style lang="scss" scoped>
.right_center{
    @apply  flex-1 overflow-y-auto mt-[26px] px-8 flex flex-col mb-10;
	&::-webkit-scrollbar{
		display: none;
	}
}
.title{
	// 一行文本超出隐藏
	@apply  w-full text-sm font-bold text-[#111111] pt-[6px] pb-[5px] px-[20px];
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
	border-top: 1px solid #E5E5E5;
	border-bottom: 1px solid #E5E5E5;
}

</style>